import { Injectable, inject } from '@angular/core';
import { Observable, of as observableOf } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { TopServiceModel } from './model';
import { TopServiceState } from './state';
import * as selectors from './selectors';
import * as actions from './actions';
import { UserFacade } from '../../user/facade';

@Injectable()
export class TopServiceFacade {
  private store = inject<Store<TopServiceState>>(Store);
  private userFacade = inject(UserFacade);

  public entities$ = this.store.pipe(select(selectors.allSelector));

  constructor() {
    this.getAll();
  }

  public getAll() {
    this.userFacade.selected().subscribe(user => {
      if (user) {
        this.store.dispatch(new actions.GetAllRequest());
      }
    });
  }

  public upPriority(entity: TopServiceModel) {
    this.store.dispatch(new actions.UpPriorityRequest(entity));
  }

  public downPriority(entity: TopServiceModel) {
    this.store.dispatch(new actions.DownPriorityRequest(entity));
  }

  public save(entity: TopServiceModel) {
    this.store.dispatch(new actions.SaveRequest(entity));
  }

  public delete(id: number) {
    this.store.dispatch(new actions.DeleteRequest(id));
  }

  public sync() {
    this.store.dispatch(new actions.SyncRequest());
  }

  public getError(): Observable<any> {
    return this.store.pipe(select(selectors.errorSelector));
  }

  public isLoading(): Observable<boolean> {
    return this.store.pipe(select(selectors.isLoadingSelector));
  }
}
